import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import { role, roleid, token } from "../Actions/AuthAction";
import { selectedJobCandidatesList } from "../Actions/CandidateAction";
import { getCity } from "../Actions/CommonAction";
import {
  getJobsDetails,
  getListUniversityJobApproval,
} from "../Actions/JobAction";
import { SelectedCandidateList } from "../Candidate/SelectedCandidateList";
import Shimmer from "../Common/Shimmer";
import { AddJob } from "./AddJob";
import FormApproval from "./FormApproval";
import UniversityApprovalMessage from "./UniversityApprovalMessage";
import CONFIG from "../../config";
const JobDetail = () => {
  const [jobDetails, setjobDetails] = useState(null);
  const [userrole, setrole] = useState(null);
  const [edit, setedit] = useState(false);
  const [message, setmessage] = useState(null);
  const [selectedCandidateList, setselectedCandidateList] = useState(null);

  const jobId = useParams();

  useEffect(() => {
    selectedJobCandidatesList({
      loginusertoken: token(),
      jobid: jobId.jobid,
    }).then((res) => {
      if (res.status) {
        let newData = [];
        res.data.map((item) => newData.push(item.candidate));
        setselectedCandidateList(newData);
      }
    });
    getJobsDetails(jobId).then((res) => {
      setjobDetails(res.data[0]);
      getmsg(res.data[0].jobid);
    });
    setrole(role());
  }, []);
  const getmsg = (getjobid = jobDetails.jobid) => {
    getListUniversityJobApproval({
      key: token(),
      page: "-1",
      jobid: getjobid,
    }).then((res) => {
      setmessage(res.data);
    });
  };
  return (
    <>
      {edit ? (
        <>
          <AddJob setedit={setedit} edit={true} jobDetails={jobDetails} />
        </>
      ) : jobDetails ? (
        <div className="row">
          <div className="col-md-12">
            <div className="card formcard mb-3">
              <div className="card-body">
                <div className="d-flex justify-content-between  border-bottom">
                  <div class="col-md-10">
                    <div className="d-flex justify-content-start">
                      <img
                        src={`${CONFIG.IMAGE_URL}/${jobDetails.employee.logo}`}
                        className="company_logo"
                      />
                      <div className="ml-3">
                        <h4 className="mb-0">
                          <a href="#">{jobDetails.jobdesignation} </a>
                        </h4>
                        <div className="d-flex mb-3">
                          <span className="mr-2">
                            <i className="text-danger fas fa-university mt-2 ml-2"></i>{" "}
                            {jobDetails.employee.companyname}
                          </span>
                          <span className="mx-2">
                            <i className="text-danger fas fa-cube mt-2"></i>{" "}
                            {jobDetails.sector.sectorname}
                          </span>
                          <span className="mx-2">
                            <i className="text-danger fas fa-map-marker mt-2"></i>{" "}
                            {jobDetails.joblocationmaps.map((item, key) => (
                              <>
                                <span className="badge badge-pill badge-secondary mx-1">
                                  {item.city.name}
                                </span>{" "}
                              </>
                            ))}
                          </span>
                          <span className="mx-2">
                            <i className="text-danger fas fa-clone mt-2"></i>{" "}
                            {jobDetails.jobtype}
                          </span>
                          <span className="mx-2">
                            <i className="text-danger fas fa-wallet mt-2"></i>{" "}
                            <span className="font-weight-bold">₹</span>
                            {jobDetails.costtocompanystart} -{" "}
                            {jobDetails.costtocompanyend} LPA
                          </span>
                        </div>
                        {/* <span className="d-flex"><i className="text-danger dashboardiconimg fas fa-university mt-2"></i> {jobDetails.employee.companyname}
                    <i className="text-danger dashboardiconimg fas fa-building mt-2"></i> {jobDetails.sector.sectorname}</span> */}
                      </div>
                      <div></div>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div className="d-flex justify-content-end">
                      {jobDetails.institutestatus == 1 ? (
                        <a
                          className="btn btn-secondary-custom mx-2 d-block mb-2"
                          href="#"
                        >
                          Not Verified
                        </a>
                      ) : jobDetails.institutestatus == 2 ? (
                        <a
                          className="btn btn-secondary-custom mx-2 d-block mb-2"
                          href="#"
                        >
                          Verified
                        </a>
                      ) : (
                        <Link
                          className="btn btn-secondary-custom mx-2 d-block mb-2"
                          to="/listjob"
                        >
                          <i class="fas fa-arrow-left"></i> Back
                        </Link>
                      )}
                      {userrole == "Recruiter" ? (
                        <button
                          class="btn btn-secondary-custom mb-2"
                          onClick={() => setedit(!edit)}
                        >
                          Edit
                        </button>
                      ) : null}
                    </div>
                  </div>
                </div>
                <div className="card-header1">Basic Details</div>
                <div className="d-flex justify-content-between joblisting">
                  <div className="col-md-12">
                    <table
                      className="table border-0"
                      width="100%"
                      cellspacing="0"
                    >
                      <tbody>
                        <tr>
                          <td className="border-0 font-weight-bold">Job id:</td>
                          <td className="border-0">#{jobDetails.jobid}</td>
                        </tr>
                        <tr>
                          <td className="border-0 font-weight-bold">
                            Special Requirement:
                          </td>
                          <td
                            className="border-0"
                            dangerouslySetInnerHTML={{
                              __html: jobDetails.specialrequirement,
                            }}
                          />
                        </tr>
                        <tr>
                          <td className="border-0 font-weight-bold">
                            Job Description:
                          </td>
                          <td
                            className="border-0"
                            dangerouslySetInnerHTML={{
                              __html: jobDetails.jobdescription,
                            }}
                          />
                        </tr>
                        <tr>
                          <td className="border-0 font-weight-bold">
                            Key Responsibilities:
                          </td>
                          <td
                            className="border-0"
                            dangerouslySetInnerHTML={{
                              __html: jobDetails.keyresponsibility,
                            }}
                          />
                        </tr>
                        <tr>
                          <td className="border-0 font-weight-bold">
                            Contract Details:
                          </td>
                          <td
                            className="border-0"
                            dangerouslySetInnerHTML={{
                              __html: jobDetails.contractdetails,
                            }}
                          />
                        </tr>
                        <tr>
                          <td className="border-0 font-weight-bold">
                            Perks & Benifits:
                          </td>
                          <td
                            className="border-0"
                            dangerouslySetInnerHTML={{
                              __html: jobDetails.perksandbenefits,
                            }}
                          />
                        </tr>
                        <tr>
                          <td className="border-0 font-weight-bold">
                            Payroll Type:
                          </td>
                          <td className="border-0">{jobDetails.payrolltype}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="card-header1">Eligiblities Criteria</div>
                <div className="d-flex justify-content-between joblisting">
                  <div className="col-md-12">
                    <table
                      className="table border-0"
                      width="100%"
                      cellspacing="0"
                    >
                      <tbody>
                        <tr>
                          <td className="border-0 font-weight-bold">
                            Bond Details:
                          </td>
                          <td
                            className="border-0"
                            dangerouslySetInnerHTML={{
                              __html: jobDetails.bonddetails,
                            }}
                          />
                        </tr>

                        <tr>
                          <td className="border-0 font-weight-bold">
                            No of Vacancies:
                          </td>
                          <td className="border-0">{jobDetails.noofvacancy}</td>
                        </tr>
                        <tr>
                          <td className="border-0 font-weight-bold">Skills:</td>
                          <td className="border-0">
                            {jobDetails.jobskillmap.map((item, key) => (
                              <>
                                <span className="badge badge-pill badge-primary mx-1">
                                  {item.skillcode0.skillname}
                                </span>{" "}
                              </>
                            ))}
                          </td>
                        </tr>
                        <tr>
                          <td className="border-0 font-weight-bold">
                            Job type:
                          </td>
                          <td className="border-0">{jobDetails.jobtype}</td>
                        </tr>
                        <tr>
                          <td className="border-0 font-weight-bold">
                            Drive Type:
                          </td>
                          <td className="border-0">
                            {jobDetails.typeofplacement}
                          </td>
                        </tr>
                        {jobDetails.min10th && (
                          <tr>
                            <td className="border-0 font-weight-bold">
                              Minimum 10th Percentage:
                            </td>
                            <td className="border-0">{jobDetails.min10th}%</td>
                          </tr>
                        )}
                        {jobDetails.min12th && (
                          <tr>
                            <td className="border-0 font-weight-bold">
                              Minimum 12th Percentage:
                            </td>
                            <td className="border-0">{jobDetails.min12th}%</td>
                          </tr>
                        )}
                        {jobDetails.mingrad && (
                          <tr>
                            <td className="border-0 font-weight-bold">
                              Minimum Graduation Percentage:
                            </td>
                            <td className="border-0">{jobDetails.mingrad}%</td>
                          </tr>
                        )}
                        {jobDetails.minpostgrad && (
                          <tr>
                            <td className="border-0 font-weight-bold">
                              Minimum Post-Graduation Percentage:
                            </td>
                            <td className="border-0">
                              {jobDetails.minpostgrad}%
                            </td>
                          </tr>
                        )}
                        {jobDetails.registeredlink && (
                          <tr>
                            <td className="border-0 font-weight-bold">
                              Registeration Link:
                            </td>
                            <td className="border-0">
                              {jobDetails.registeredlink}
                            </td>
                          </tr>
                        )}
                        <tr>
                          <td className="border-0 font-weight-bold">
                            Training Period:{" "}
                          </td>
                          <td className="border-0">
                            {jobDetails.trainingperiod}
                          </td>
                        </tr>
                        <tr>
                          <td className="border-0 font-weight-bold">
                            Created On:{" "}
                          </td>
                          <td className="border-0">{jobDetails.created_on}</td>
                        </tr>
                        <tr>
                          <td className="border-0 font-weight-bold">
                            Training Period:{" "}
                          </td>
                          <td className="border-0">
                            {jobDetails.trainingperiod}
                          </td>
                        </tr>
                        <tr>
                          <td className="border-0 font-weight-bold">
                            Training Period:{" "}
                          </td>
                          <td className="border-0">
                            {jobDetails.trainingperiod}
                          </td>
                        </tr>
                        <tr>
                          <td className="border-0 font-weight-bold">
                            Salary:{" "}
                          </td>
                          <td className="border-0">
                            ₹{jobDetails.costtocompanystart} -{" "}
                            {jobDetails.costtocompanyend} LPA
                          </td>
                        </tr>
                        <tr>
                          <td className="border-0 font-weight-bold">
                            Location:
                          </td>
                          <td className="border-0">
                            {jobDetails.joblocationmaps.map((item, key) => (
                              <>
                                <span className="badge badge-pill badge-secondary mx-1">
                                  {item.city.name}
                                </span>{" "}
                              </>
                            ))}
                          </td>
                        </tr>
                        <tr>
                          <td className="border-0 font-weight-bold">
                            Courses:
                          </td>
                          <td className="border-0">
                            {jobDetails.jobcoursemaps.map((item, key) => (
                              <>
                                <span className="badge badge-pill badge-secondary mx-1">
                                  {item.course.name}
                                </span>{" "}
                              </>
                            ))}
                          </td>
                        </tr>
                        <tr>
                          <td className="border-0 font-weight-bold">
                            Year of Passing:
                          </td>
                          <td className="border-0">
                            {jobDetails.yearofpassing
                              .split(",")
                              .map((item, key) => (
                                <>
                                  <span className="badge badge-pill badge-secondary mx-1">
                                    {item}
                                  </span>{" "}
                                </>
                              ))}
                          </td>
                        </tr>
                        <tr>
                          <td className="border-0 font-weight-bold"></td>
                          <td className="border-0">
                            {userrole == 5 && (
                              <a
                                className="btn btn-primary-custom mx-2 mb-2"
                                href="#"
                              >
                                Apply{" "}
                              </a>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  {/* <div className="col-md-2 d-flex align-items-center justify-content-center">
                  <div>
                    <a className="btn btn-primary-custom mx-2 d-block mb-2" href="#">Apply </a>
                    <a className="btn btn-secondary-custom mx-2 d-block mb-2" href="#">Verified</a>
                  </div>
                </div> */}
                </div>
              </div>
            </div>
            {roleid() == 6 ||
            roleid() == 3 ||
            roleid() == 2 ||
            roleid() == 1 ? (
              <>
                {message ? (
                  <UniversityApprovalMessage
                    message={message}
                    jobid={jobDetails.jobid}
                    universitylist={jobDetails.university}
                  />
                ) : (
                  <Shimmer />
                )}
              </>
            ) : null}
            {roleid() != 5 &&
            message &&
            ((message[message.length - 1] &&
              message[message.length - 1].status != 2) ||
              message.length == 0) ? (
              <>
                {" "}
                {roleid() == 6 || roleid() == 2 || roleid() == 1 ? (
                  <FormApproval
                    getmsg={getmsg}
                    jobid={jobDetails.jobid}
                    recid={jobDetails.created_by}
                  />
                ) : (
                  <span></span>
                )}
              </>
            ) : null}
            {roleid() != 5 && selectedCandidateList ? (
              <SelectedCandidateList candidateList={selectedCandidateList} />
            ) : null}
          </div>
        </div>
      ) : (
        <Shimmer />
      )}
    </>
  );
};

export default JobDetail;
